import { StyleSheet } from 'aphrodite'

import list from './list'
import navbar from './navbar'

export default {
  list: StyleSheet.create(list),
  navbar: StyleSheet.create(navbar)
}



// WEBPACK FOOTER //
// ./src/components/partials/DashboardNavigation/style/index.js